

import { getBezierPath, type ConnectionLineComponentProps, type InternalNode } from '@xyflow/react';

import { getEdgeParams } from '../utils/position';

/**
 * Custom Floating Connection Line that follows floating logic while dragging.
 */
export function FloatingConnectionLine({
  toX,
  toY,
  fromNode,
}: ConnectionLineComponentProps) {
  if (!fromNode) {
    return null;
  }

  const targetNode = {
    id: 'connection-line',
    measured: { width: 1, height: 1 },
    internals: {
      positionAbsolute: { x: toX, y: toY },
    },
  } as unknown as InternalNode;

  const { sx, sy, sourcePos, targetPos } = getEdgeParams(fromNode as unknown as InternalNode, targetNode);

  const [edgePath] = getBezierPath({
    sourceX: sx,
    sourceY: sy,
    sourcePosition: sourcePos,
    targetPosition: targetPos,
    targetX: toX,
    targetY: toY,
  });

  return (
    <g>
      <path
        fill="none"
        stroke="#3b82f6"
        strokeWidth={2}
        className="animated"
        d={edgePath}
      />
      <circle
        cx={toX}
        cy={toY}
        fill="#fff"
        r={3}
        stroke="#3b82f6"
        strokeWidth={1.5}
      />
    </g>
  );
}

export default FloatingConnectionLine;
